
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M101.5 4A15.55 15.55 0 01117 19.56V47h-2a2 2 0 00-2 2v12.58a2 2 0 002 2h2v15.14a2 2 0 004 0V63.58h2a2 2 0 002-2V49a2 2 0 00-2-2h-2V19.56a19.5 19.5 0 10-39 0V31h-4a2 2 0 00-2 2v33a2 2 0 002 2h4v32.39a23.5 23.5 0 11-47 0V100h5a2 2 0 002-2v-5.42c14-1.52 24-10.1 24-15.85V16.8A10.81 10.81 0 0055.22 6h-5.43c-4 0-7.15-1.8-9.87-3.39C37.61 1.27 35.43 0 33 0s-4.61 1.27-6.92 2.61C23.36 4.2 20.26 6 16.21 6h-5.43A10.81 10.81 0 000 16.8v59.93C0 82.49 10.41 91 24 92.57V98a2 2 0 002 2h5v.39a27.5 27.5 0 1055 0V68h4a2 2 0 002-2V33a2 2 0 00-2-2h-4V19.56A15.55 15.55 0 01101.5 4zM121 59.58h-4V51h4zM33 4c1.32 0 2.93.92 4.78 2h-9.56c1.85-1.08 3.46-2 4.78-2zm-22.22 6h44.44A6.8 6.8 0 0162 16.8v16.11a43.79 43.79 0 01-8-.93 48.63 48.63 0 00-10.72-1 48.45 48.45 0 00-10.71 1 45 45 0 01-9.95 1 45 45 0 01-10-1A46.92 46.92 0 004 31V16.8a6.8 6.8 0 016.78-6.8zM4 76.73V35a43.79 43.79 0 018 .93 48.56 48.56 0 0010.72 1 48.53 48.53 0 0010.71-1 45 45 0 019.95-1 45 45 0 0110 1 46.07 46.07 0 008.71 1v39.8c0 3.49-9.7 12.09-24.34 12.09h-9.41C13.83 88.82 4 79.75 4 76.73zm24 16.09h10V96H28zM88 64h-8V35h8zm32.47 20.59a2 2 0 00-2.83 0c-.77.77-7.52 7.69-7.52 13.47a8.94 8.94 0 0017.88 0c0-5.78-6.76-12.7-7.53-13.47zM119.06 103a4.94 4.94 0 01-4.94-4.94c0-2.56 2.63-6.45 4.94-9.11 2.3 2.66 4.94 6.55 4.94 9.11a5 5 0 01-4.94 4.94z"}})])
          )
        }
      }
    